<template>
  <div class="columns">
    <div class="column">
      <button class="button is-primary" v-on:click="openTab($store.state.chargifyUrl)">
        Billing and subscription portal
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openTab(url) {
      console.log("openTab()", url);
      var win = window.open(url, "_blank");
      win.focus();
    }
  }
};
</script>

<style>
</style>
